import React from 'react';

import styles from './button.module.scss';
import DefaultLoader from './defaultLoader';
import { classnames } from '../util';

export type ButtonProps = {
  text: string;
  name: string;
  color: string;
  disabled: boolean;
  large?: boolean;
  showSpinner?: boolean;
  onClick: (e: any) => void;
};

const Button = (props: ButtonProps) => {
  return (
    <button
      className={classnames(styles.Button, {
        [styles['red']]: props.color === 'red',
        [styles['gray']]: props.color === 'gray',
        [styles['large']]: !!props.large,
        [styles['disabled']]: props.disabled,
      })}
      onClick={props.onClick}
      name={props.name}
      disabled={props.disabled}
    >
      {!!props.showSpinner && <DefaultLoader color='secondary' type='block' />}
      {props.text}
    </button>
  );
};

export default Button;
